import { Component, OnInit, OnDestroy } from '@angular/core';

import { Router } from '@angular/router';

import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { Observable, Subscription } from 'rxjs';

import { MatDialog } from '@angular/material/dialog';

import { Project } from '../firestore-models/project';
import { Facility } from '../firestore-models/facility';
import { ApiProject } from '../api-client-module';
import { ApiSetProjectsRequest } from '../api-client-module';
import { Language } from '../firestore-models/language';

import { ApiClientService } from '../api-client.service';
import { ConfigurationService } from '../configuration.service';
import { AppConst } from '../app-const';
import { ProjectDialogComponent } from './project-dialog/project-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { ProjectLanguage,ProjectLanguageClass } from '../firestore-models/project-language';


@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.css'],
  standalone: false,
})
export class ProjectComponent implements OnInit, OnDestroy {

  // プロジェクト情報
  readonly projectLink = AppConst.ROUTING_LINK_PROJECT;
  // ユーザータイプ
  readonly USER_TYPE_ADMIN: number = AppConst.MANAGE_USER_TYPE_ADMIN;
  readonly USER_TYPE_MASTER: number = AppConst.MANAGE_USER_TYPE_MASTER;

  private projectsDocument!: AngularFirestoreDocument<Project>;
  projectsObservable!: Observable<Project>;
  projectsSubscribe!: Subscription;
  projectId!: string;
  project!: Project;

  private facilitiesCollection!: AngularFirestoreCollection<Facility>;
  facilitiesObservable!: Observable<Facility[]>;
  facilitiesSubscribe!: Subscription;
  facilities: Array<Facility> = [];

  private languagesCollection!: AngularFirestoreCollection<Language>;
  languagesObservable!: Observable<Language[]>;

  userType!: number;

  projectLanguages: Array<ProjectLanguage> = [];
  projectLanguageClasses!: Array<ProjectLanguageClass>; 
  currentLang: string = 'ja';

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private angularFirestore: AngularFirestore,
    private configurationService: ConfigurationService,
    private apiClientService: ApiClientService,
    private translate: TranslateService,
  ) {
    this.projectId = this.configurationService.getProjectId();
    this.userType = this.configurationService.getUserType();
  }

  ngOnInit(): void {
    
    this.projectsDocument = this.angularFirestore.doc<Project>(`${AppConst.FIRESTORE_PROJECTS}/${this.projectId}`);
    // this.projectsObservable = this.projectsDocument.valueChanges();
    this.projectsSubscribe = this.projectsDocument.valueChanges().subscribe(project => {
      this.project = project!;

    });
    // 施設取得
    this.facilitiesCollection = this.angularFirestore.collection<Facility>(
      AppConst.FIRESTORE_FACILITIES, ref => ref.where('project_id', '==', this.projectId).orderBy('facility_id', 'asc'));
    this.facilitiesObservable = this.facilitiesCollection.valueChanges({ idField: 'id' });
    this.facilitiesSubscribe = this.facilitiesObservable.subscribe(facilities => {
      this.facilities = facilities;
    });

    this.languagesCollection = this.angularFirestore.collection<Language>('language');
    this.languagesObservable = this.languagesCollection.valueChanges({ idField: 'id' });

    //admin_lang_modeの値をproject情報に登録
    // this.projectsDocument.valueChanges().subscribe(project => {
    //   this.project = project!;
    // });
    
    // this.updateAdminLangMode(this.project);

    //${this.projectId} から　firestoreからProject情報を取得
    // this.projectsDocument = this.angularFirestore.doc<Project>(`${AppConst.FIRESTORE_PROJECTS}/${this.projectId}`);
    //取得したProject情報について、admin_lang_modeの値を更新
    // this.projectsSubscribe = this.projectsDocument.valueChanges().subscribe(project => {
    //   this.project = project!;
    //   this.updateAdminLangMode(this.project);
    // });
    this.currentLang = this.translate.currentLang;
    // this.projectLanguages = this.project.languages;
    // this.projectLanguageClasses = this.projectLanguages.map((projectLanguage) => {
    //   return new ProjectLanguageClass(projectLanguage);
    // });

// console.log('projectLanguageClasses:' + this.projectLanguageClasses);
    
  }

  ngOnDestroy(): void {
    this.projectsSubscribe.unsubscribe();
  }

  openEditDialog(project: Project): void {
    let apiProject: ApiProject = {
      project_id: project.project_id,
      project_name: project.project_name,
      project_app_names: project.project_app_names,
      project_desc: project.project_desc,
      latitude: project.project_geopoint && project.project_geopoint.latitude ? project.project_geopoint.latitude : AppConst.LATITUDE_INITIAL_VALUE,
      longitude: project.project_geopoint && project.project_geopoint.longitude ? project.project_geopoint.longitude : AppConst.LONGITUDE_INITIAL_VALUE,
      languages: project.languages,
      maintenance_flag: project.maintenance_flag,
      enabled: project.enabled,
      facility_registration_limit: project.facility_registration_limit,
      keypad_type: project.keypad_type,
      trans_base_lang: project.trans_base_lang,
      project_base_lang: project.project_base_lang,
      use_trans_base_lang_ko: project.use_trans_base_lang_ko,
      use_trans_base_lang_yuehk: project.use_trans_base_lang_yuehk,
      use_trans_base_lang_zhcn: project.use_trans_base_lang_zhcn,
      use_trans_base_lang_zhtw: project.use_trans_base_lang_zhtw,
    }
    const dialogRef = this.dialog.open(ProjectDialogComponent, {
      width: '60%',
      disableClose: true,
      data: { change_type: AppConst.DATA_CHANGE_TYPE_UPDATE, project: apiProject }
    });
  }

  updateAdminLangMode(project: Project): void {
    
    const apiProject: ApiProject = {
      project_id: project.project_id,
      project_name: project.project_name,
      project_app_names: project.project_app_names,
      project_desc: project.project_desc,
      latitude: project.project_geopoint.latitude,
      longitude: project.project_geopoint.longitude,
      languages: project.languages,
      maintenance_flag: project.maintenance_flag,
      enabled: project.enabled,
      facility_registration_limit: project.facility_registration_limit,
      keypad_type: project.keypad_type,
      trans_base_lang: project.trans_base_lang,
      project_base_lang: project.project_base_lang,
      use_trans_base_lang_ko: project.use_trans_base_lang_ko,
      use_trans_base_lang_yuehk: project.use_trans_base_lang_yuehk,
      use_trans_base_lang_zhcn: project.use_trans_base_lang_zhcn,
      use_trans_base_lang_zhtw: project.use_trans_base_lang_zhtw,
    }
    
    const request: ApiSetProjectsRequest = {
      access_token: '',
      change_type: AppConst.DATA_CHANGE_TYPE_UPDATE,
      projects: [apiProject]
    }
    this.apiClientService.setProjects(request).then(
      response => {
        if (response!.ret === AppConst.API_RET_SUCCESS) {
          // this.toastr.success(this.translate.instant('更新しました。'));
        } else {
          // this.toastr.error(this.translate.instant('更新できませんでした。'));
        }
      }
    ).catch(
      error => {
        console.log(error);
        // this.toastr.error(this.translate.instant('更新できませんでした。'));
      }
    ).finally(
      () => {
      }
    );
  }

}
